<div
    class="container-tab tab-{{index}}"
    [hidden]="!active"
    [ngClass]="{'show-tab': active}"
>
    <ng-content></ng-content>
</div>
